import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import imoveisReducer from '../reducers/imoveis';
import moveisReducer from '../reducers/moveis';
import authReducer from '../reducers/auth';

// Only enable Redux DevTools in development
const composeEnhancers =
  process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

export default () => {
  const store = createStore(
    combineReducers({
      auth: authReducer,
      imoveis: imoveisReducer,
      moveis: moveisReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

  return store;
};
